import type { AxiosError, AxiosResponse, Method, ResponseType } from 'axios';

export enum QueryStringFormat {
  FORM_EXPLODE = 'FORM_EXPLODE',
  FORM_NO_EXPLODE = 'FORM_NO_EXPLODE',
}

export interface FetcherOptions<ResponseData> {
  url: string;
  query?: object;
  method?: Method;
  body?: unknown;
  queryStringFormat?: QueryStringFormat;
  headers?: Record<string, string | number | boolean>;
  responseType?: ResponseType;
  // Optional alternative callback to run when the request is resolved
  // onFulfilled?: ((value: ResponseData) => ResponseData | PromiseLike<ResponseData>) | undefined | null;
  onFulfilled?: (value: AxiosResponse<ResponseData>) => object;
}

export type FetchError<ErrorBody = unknown> = AxiosError<ErrorBody> | Error;

export type CustomQueryOptions<ResponseData = object> = {
  headers?: Record<string, string | number | boolean>;
  fetcherOptions?: Partial<FetcherOptions<ResponseData>>;
};
